import React, {Component} from 'react';
import { Col, Label, FormGroup } from "reactstrap";
import Select from 'react-select';
import { setTemaSeletor } from "../../../utils/formatar";
import {IconeCarregar, IconeInformacao} from './Icones';

export default class FormSelectSimples extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mostrarOpcoes: !this.props.buscaMinima,
            noOptionsMessage: !this.props.buscaMinima ? "Sem opções" : `Informe ${this.props.buscaMinima} ou mais caracteres`
        };
        var naoPreencherAutomaticamenteCasoApenasUmRegistro = this.props.naoPreencherAutomaticamenteCasoApenasUmRegistro;
        console.log(naoPreencherAutomaticamenteCasoApenasUmRegistro);
        let qtdRegistros;
        if(!naoPreencherAutomaticamenteCasoApenasUmRegistro){
            qtdRegistros = 1;  
        }else{
            qtdRegistros = undefined;
        }
              
        this.handleChange = this.handleChange.bind(this);
        /* Caso o componente tenha apenas 1 registro no seu resultado, ele é preeenchido com esse valor automaticamente */
        this.dado = {
            label : (this.props.itens && this.props.itens.length === qtdRegistros) ? this.props.itens[0].label : '',
            value: (this.props.itens && this.props.itens.length === qtdRegistros) ? this.props.itens[0].value : null            
        }
        /* Executa o onChange caso componente possua algum outro evento dependente da seleção desse */
        if (this.dado.value)
            this.handleChange(this.dado);
    };

    onInputChange = (inputValue) => {
        /*  Se existir busca mínima, verifica se a busca ja tem tamanho suficiente
            Se não existir busca mínima, carrega opções quando elas ainda não existe. */
        if (!this.props.buscaMinima || inputValue.length >= this.props.buscaMinima) {
            this.setState({
                mostrarOpcoes: true,
                noOptionsMessage: "Sem opções"
            });
        } else {
            this.setState({
                mostrarOpcoes: false,
                noOptionsMessage: `Informe ${this.props.buscaMinima} ou mais caracteres`
            });
        }
    };

    filtro(option, searchText) {
        if (option.label && option.label.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
        } else {
            return false;
        }
    };

    handleChange = (event) => {
        this.props.onChange(event, event);
    };

    render() {
        let options = this.props.itens ? this.props.itens : [];

        return(
            <Col 
                className={this.props.className ? this.props.className+" form-select-simples" : "form-select-simples"}
                 xs={this.props.xs || ''}
                 sm={this.props.sm || ''}
                 md={this.props.md || ''}
                 lg={this.props.lg || ''}
                 xl={this.props.xl || ''}
            >
                <div className="w-100">
                    { this.props.titulo && <Label>{ this.props.titulo } { this.props.obrigatorio ? <span className="label-danger">*</span> : "" } </Label> }
                    <Select className="select" menuPlacement="auto" placeholder="Selecione"
                            noOptionsMessage={ () => this.state.noOptionsMessage }
                            isSearchable={ options.length>5 || options.length===0 } // Não mude o length===0
                            value={ this.props.carregando ? { label: this.props.carregando } : (this.dado.value ? this.dado : this.props.dado) }
                            isDisabled={ this.props.bloqueado ? this.props.bloqueado : false }
                            onChange={ this.handleChange }
                            options={ this.state.mostrarOpcoes ? options : [] }
                            theme={theme => setTemaSeletor(theme)}
                            isClearable={!this.props.naoLimpar}
                            // defaultMenuIsOpen={true}
                            onInputChange={ this.onInputChange }
                            filterOption={this.filtro} />
                </div>
                { this.props.alerta && <Label className="label-danger">{ this.props.alerta }</Label> }
                <div className="d-flex align-items-center">
                    {this.props.iconeInfo && <div><IconeInformacao className="mr-1" /></div>}
                    {this.props.informacoes ? <Label className="informacoes mb-0">{this.props.informacoes}</Label> : ""}
                </div>
                {/* { this.props.informacoes && <Label className="informacoes">{ this.props.informacoes }</Label> } */}
            </Col>
        )
    };
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormSelectSimples.js